// This file is generated by bin/generate-theme.ts

// FontSizes design tokens
export const fontSizes = {
  xs: '12px',
  s: '14px',
  m: '16px',
  l: '18px',
};

export type FontSizesTokens = typeof fontSizes;
export type FontSizesKey = keyof FontSizesTokens;
